<section id="products-section" class="feat-pro2 pt-4" style="min-height: 1300px">
  <div class="container">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <h2 class="p-2 font-weight-bold text-center section-title">Mejores productos</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 padding-fix-l20">
        <div class="ftr-product">
          <div class="tab-box d-flex justify-content-center text-center">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs center-nav-tabs" role="tablist">
              <li class="nav-item">
                <a (click)="updatePayload(1)" class="nav-link active px-1 px-md-2" data-toggle="tab" href="#treading-items">Recomendados</a>
              </li>
              <li class="nav-item">
                <a (click)="updatePayload(2)" class="nav-link px-1 px-md-2" data-toggle="tab" href="#new-arrivals">Descuentos</a>
              </li>
              <li class="nav-item">
                <a (click)="updatePayload(3)" class="nav-link px-1 px-md-2" data-toggle="tab" href="#newest">Novedosos</a>
              </li>
              <li class="nav-item">
                <a (click)="updatePayload(4)" class="nav-link px-1 px-md-2" data-toggle="tab" href="#best-sale">Recién llegados</a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div class="tab-pane fade active show" id="treading-items" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 1}"></ng-container>

              <!--<div class="d-flex flex-column align-items-center">
                <div class="d-flex flex-column flex-md-row">
                  <div class="post-50 special-offer market-bg-color-red d-flex flex-column flex-lg-row align-items-center align-items-lg-start justify-content-lg-start align-items-start p-4 position-relative"
                       style="border-radius:15px">
                    <div class="d-flex flex-column mt-4 w-100 align-items-center align-items-lg-start">
                      <span class="h2 product-title text-center text-lg-left" style="max-width: 150px;color:#7B0E0E; ">Comprar para Cuba</span>
                      <span class="text-white text-center product-subtitle d-block d-lg-none"
                            style="max-width: 150px;font-weight:bold">nunca ha sido más fácil.</span>
                      <span class="mt-3 text-white product-subtitle d-none d-lg-block"
                            style="max-width: 150px;font-weight:bold">nunca ha sido más fácil.</span>
                      <div class="position-absolute pb-2 d-flex justify-content-center justify-content-lg-start cta">
                        <button (click)="callToAction(DeepLinkType.Market, 'home', 'market3')"
                                class="btn bg-white px-2 py-2 py-lg-3 font-weight-bold OpenSans rounded-pill w-75 position-absolute product-button"
                                style="color: #FB8E8E; font-size: 24px">
                          Comprar Ahora
                          <ng-container *ngIf="deepLink != 'market3'; else snippet"></ng-container>
                        </button>
                      </div>
                    </div>
                    <img class="d-block d-md-none" width="250px" src="assets/market/alimientos1.png" alt="Alimentos">
                    <img class="d-none d-md-block d-lg-none" width="360px" src="assets/market/alimientos1.png" alt="Alimentos">
                    <img class="d-none d-lg-block d-xl-none" width="360px" src="assets/market/alimientos1.png" alt="Alimentos">
                    <img class="d-none d-xl-block" width="420px" src="assets/market/alimientos1.png" alt="Alimentos">
                  </div>
                  <div class="post-50 d-flex flex-column">
                    <div class="d-flex market-bg-color-blue justify-content-center px-3 px-lg-4 pt-3 pt-lg-4 position-relative my-3"
                         style="border-radius:15px">
                      <div class="d-flex flex-column mb-md-5 mb-xl-0">
                        <span class="text-white product-title-2" style="max-width: 210px;">Malta Bucanero</span>
                        <span class="mt-2 mb-lg-4 h2 product-subtitle-2" style="max-width: 210px;color:#031841">La malta preferida de los cubanos</span>
                        <div class="position-absolute pb-2 w-100 d-flex justify-content-start cta" style="bottom: 5%;">
                          <button (click)="callToAction(DeepLinkType.Market, 'home', 'market3')"
                                  class="btn bg-white px-2 py-1 font-weight-bold OpenSans rounded-pill w-75 position-relative add-cart"
                                  style="color: #0C8EFE; font-size: 16px">
                            Añadir al carrito
                            <ng-container *ngIf="deepLink != 'market3'; else snippet"></ng-container>
                          </button>
                        </div>
                      </div>
                      <img class="d-block d-md-none align-self-end" width="140" height="74" src="assets/market/malta.png" alt="Alimentos">
                      <img class="d-none d-md-block d-lg-none align-self-end" width="179" height="94" src="assets/market/malta.png" alt="Alimentos">
                      <img class="d-none d-lg-block d-xl-none" width="255" src="assets/market/malta.png" alt="Alimentos">
                      <img class="d-none d-xl-block" width="300" src="assets/market/malta.png" alt="Alimentos">
                    </div>
                    <div class="d-flex flex-column align-items-md-center">
                      <section class="feat-pro2 w-100 pt-3 pb-0">
                        <div class="container w-100">
                          <div class="row justify-content-center">
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-12 padding-fix-l20 px-0">
                                  <div class="ftr-product">
                                    <div *ngIf="!(loading$ |async); else loading_items" class="tab-slider owl-carousel" id="product-section-slider">
                                      <div class="tab-item" *ngFor="let product of products">
                                        <div class="tab-img">
                                          <div class="d-flex justify-content-center align-items-center" style="height: 0; padding-bottom: 100%">
                                            <img class="main-img img-fluid m-auto" src="{{product.pictures[0].previewUrl}}" alt="Café">
                                            <img class="sec-img img-fluid m-auto" src="{{product.pictures[0].previewUrl}}" alt="">
                                          </div>
                                        </div>
                                        <div class="tab-heading">
                                          <p ><a routerLink="productos-compras-cuba-online/detalles/{{product.code}}}">{{product.name}}</a></p>
                                        </div>
                                        <div class="img-content d-flex justify-content-between">
                                          <div >
                                            <ul class="list-unstyled list-inline fav">
                                              <ul [innerHtml]="product.rating | start" class="list-unstyled list-inline"></ul>
                                            </ul>
                                            <ul class="list-unstyled list-inline price" >
                                              <li class="list-inline-item" >
                                                <span >{{product.priceToShow}}</span>
                                              </li>
                                              <li class="list-inline-item" >
                                                <span *ngIf="product.oldPriceToShow">{{product.oldPriceToShow}}</span>
                                              </li>
                                            </ul>
                                          </div>
                                          <div>
                                            <a href="" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img src="assets/market/xemart/images/it-cart.png" alt=""></a>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
            <div class="tab-pane" id="new-arrivals" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 2}"></ng-container>
            </div>
            <div class="tab-pane" id="best-sale" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 3}"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="products-tab-box">

  </div>
</section>
<ng-template #loading_items>
  <div #product_section_slider_loading class="tab-slider" id="product-section-slider-loading">
    <div *ngFor="let number of [1,2,3,4,5,6,7,8,9,10,11,12]" class="tab-item">
      <div class="tab-img">
        <div class="d-flex justify-content-center align-items-center" style="height: 0; padding-bottom: 100%">
          <div class="animated-background animated-images mb-5" style="margin-left:1rem;margin-right: 1rem;"></div>
        </div>
      </div>
      <div class="tab-heading">
        <div class="animated-background mb-2" style="margin-left:1rem;margin-right: 1rem;"></div>
      </div>
      <div class="img-content d-flex justify-content-between">
        <div style="width:100%">

          <ul class="list-unstyled list-inline price" style="width:100%">
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
          </ul>
        </div>
        <div>
          <a href="" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img style="visibility:hidden" src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>
      <!--<div class="tab-img">
        <div class="d-flex justify-content-center align-items-center" style="height: 0; padding-bottom: 100%">
          <img class="main-img img-fluid m-auto p-2" src="assets/loading.gif" alt="Café">
        </div>
      </div>
      <div class="tab-heading">
        <div class="animated-background mb-2" style="margin-left:1rem;margin-right: 1rem;"></div>
      </div>
      <div class="img-content d-flex justify-content-between">
        <div style="width:100%">

          <ul class="list-unstyled list-inline price" style="width:100%">
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
          </ul>
        </div>
        <div>
          <a href="" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img style="visibility:hidden" src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>-->
    </div>
  </div>

</ng-template>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tabs>
  <div class="row">
    <ng-container *ngIf="loading$; else template">
      <div *ngFor="let product of [1,2,3,4,5,6,7,8,9,10,11,12]" style="display:flex;" class="col-6 col-md-4 col-lg-3 mb-4">
        <div class="tab-item">
          <div class="tab-img">

            <ngx-skeleton-loader class="d-block d-xl-none" animation="progress" animation="true" appearance="line" [theme]="theme">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader class="d-none d-xl-block" animation="progress" animation="true" appearance="line" [theme]="{ 'min-width': '175px', 'min-height': '190px', background: '#f1f1f1' }">
            </ngx-skeleton-loader>

          </div>
          <div style="min-height: 80px;" class="tab-heading">

            <ngx-skeleton-loader animation="progress" appearance="line"
                                 [theme]="{ margin: '-15px 0 0 10px', width: '160px', height: '28px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader animation="progress" appearance="line"
                                 [theme]="{ margin: '0 0 0 10px', width: '110px', height: '20px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

          </div>

          <div class="img-content d-flex justify-content-between">
            <div style="margin-top:10px">
              <ngx-skeleton-loader animation="progress" appearance="line"
                                   [theme]="{ margin: '5px 0 0 0px', width: '120px', height: '30px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
            <div>
              <ngx-skeleton-loader animation="progress" appearance="circle"
                                   [theme]="{ width: '50px', height: '50px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
          </div>


        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #template let-tab="tab">
  <div *ngFor="let product of products; let index = index;" style="display:flex;" class="col-6 col-md-4 col-lg-3 mb-4 items tab-slider">
    <div id="{{tab + '-' + product.code}}" class="tab-item d-flex flex-column">
      <div class="tab-img">
        <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="{ 'min-width': '220px', 'min-height': '190px', background: '#f1f1f1' }">
        </ngx-skeleton-loader>

        <img routerLink="productos-compras-cuba-online/cubatel/{{product.code}}" [hidden]="!product.loaded" class="main-img img-fluid cursor-pointer"
             src="{{product.pictures .length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
             (load)="product.loaded=true">
      </div>
      <div style="min-height: 80px;" class="tab-heading">
        <p>
          <a routerLink='productos-compras-cuba-online/cubatel/{{product.code}}'>{{product.name}}</a>
        </p>
        <div class="img-content d-flex justify-content-between">
          <ul title="{{product.rating}}" [innerHtml]="product.rating | start" class="list-unstyled list-inline fav"></ul>
        </div>
      </div>

      <div class="img-content d-flex justify-content-between mt-auto">
        <div style="margin-top:10px">
          <ul class="list-unstyled list-inline price">
            <li class="list-inline-item">{{product.priceToShow}}</li>
            <li class="list-inline-item">{{product.oldPriceToShow}}</li>
          </ul>
        </div>
        <div>
          <a style="width: 42px; height: 42px; text-align: center;" (click)="pushToCart(product, tab)" href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>

    </div>
  </div>
</ng-template>
